/* eslint-disable */
import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import AlertClose from 'static/images/icons/alert-close.svg'
import AlertIcon from 'static/images/icons/alert-icon.svg'

// import styles 
import styles from './AlertModal.css';

const rand = () => {
  return Math.round(Math.random() * 20) - 10
}

const getModalStyle = () => {
  const top = 50 + rand()
  const left = 50 + rand()

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  }
}

const AlertModal = props => {
  const [modalStyle] = useState(getModalStyle)
  const {
    isOpen,
    onClose,
    style,
    alertContent,
  } = props

  const ALERT_STYLE = {
    position: 'absolute',
    width: '154px',
    background: '#FFFFFF',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.12), 0px 6px 12px rgba(0, 0, 0, 0.12), 0px 1px 16px rgba(0, 0, 0, 0.12)',
    textAlign: 'center',
    borderRadius: '8px',
    height: '254px',
  }

  const useStyles = makeStyles(theme => ({
    paper: {style, ...ALERT_STYLE},
  }))
  const classes = useStyles()

  const body = (
    <React.Fragment>
      <div style={modalStyle} className={classes.paper}>
        <div className={styles.alertClose} onClick={() => onClose()}>
          <AlertClose />
        </div>
        <div className={styles.alertIcon}>
          <AlertIcon />
        </div>
        <p className={styles.alertHeaderText}>
          Oops!
        </p>
        <div className={styles.alertBodyContent}>
          {alertContent}
        </div>
      </div>
    </React.Fragment>
  )

  return (
    <div>
      <Modal
        open={isOpen}
        onClose={() => onClose()}
        aria-labelledby="alert-modal"
        aria-describedby="alert-description"
      >
        {body}
      </Modal>
    </div>
  )
}

export default AlertModal;



// WEBPACK FOOTER //
// ./src/views/components/Common/AlertModal/AlertModal.jsx